var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 89,
    viewBox: "0 0 109 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.7629 60.7937V23.7112V22.0257V0.113281H65.1753V20.3401H53.9381V45.0617H49.4433V21.4638H12.3608V45.0617H0V88.8865H109V60.7937H97.7629ZM15.732 24.8349H46.0722V29.3298H15.732V24.8349ZM15.732 32.7009H46.0722V45.0617H15.732V32.7009ZM33.7113 48.4329V64.1648H23.5979V48.4329H33.7113ZM53.9381 85.5153H3.37113V48.4329H20.2268V67.536H37.0825V48.4329H53.9381V85.5153ZM68.5464 3.48442H94.3918V20.3401H68.5464V3.48442ZM79.7835 23.7112V40.5669H71.9175V23.7112H79.7835ZM71.9175 85.5153H57.3093V23.7112H68.5464V43.938H83.1546V23.7112H94.3918V60.7937H71.9175V85.5153ZM105.629 85.5153H75.2887V64.1648H105.629V85.5153Z",
    fill: "#0054A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1392 37.1953H37.6443V40.5664H42.1392V37.1953Z",
    fill: "#0054A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3969 37.1953H30.9021V40.5664H35.3969V37.1953Z",
    fill: "#0054A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.572 69.7832H91.5825V73.1543H100.572V69.7832Z",
    fill: "#0054A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.572 76.5254H84.8402V79.8965H100.572V76.5254Z",
    fill: "#0054A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3351 12.4746H84.8402V15.8457H89.3351V12.4746Z",
    fill: "#0054A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5928 12.4746H78.098V15.8457H82.5928V12.4746Z",
    fill: "#0054A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.251bc68bddaf1acedf8a64a54fe88208.svg";
export { ForwardRef as ReactComponent };